import { render, staticRenderFns } from "./Crumbs.vue?vue&type=template&id=01509694&scoped=true&"
import script from "./Crumbs.vue?vue&type=script&lang=js&"
export * from "./Crumbs.vue?vue&type=script&lang=js&"
import style0 from "./Crumbs.vue?vue&type=style&index=0&id=01509694&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01509694",
  null
  
)

export default component.exports